import { FC } from 'react';

import { Background } from '@components';

import styles from './index.module.scss';

type Item = {
	title: string;
	value: string | number;
};

type Props = {
	data: Item[];
};

export const Stats: FC<Readonly<Props>> = ({ data }) => (
	<div className={styles.stats} data-testid="stats">
		<Background type="dark" />

		<ul>
			{data.map(item => (
				<li key={item.title}>
					<h4>{item.title}</h4>
					<p>{item.value}</p>
				</li>
			))}
		</ul>
	</div>
);

export default Stats;
